import styles from "./styles.module.css";

export default function Button({
  onClick,
  children,
  ...props
}) {
  return (
    <button onClick={onClick} className={styles.button} {...props}>
      {children}
    </button>
  );
}
